module.exports = __webpack_public_path__ + "img/CV.Earthworks.Site_Clearance.Rural_site_clearance.1e1dd6a7.png";